import styled, { css } from "styled-components";

interface IProps {
  mine: boolean;
}

const StandingsRow = styled.tr<IProps>`
  ${(props) =>
    props.mine &&
    css`
      && {
        background-color: ${({ theme }) => theme.colors.white8};
      }
      td {
        color: ${({ theme }) => theme.colors.white1};
        > a {
          color: ${({ theme }) => theme.colors.white};
        }
      }
    `}
`;
export default StandingsRow;
